const filters = {
    // 日期格式
    dateFormat: function(params) {
        if (params) {
            let num = params.toString()
            let [year, month, day] = [num.slice(0, 4), num.slice(4, 6), num.slice(6, 8)]
            return `${year}/${month}/${day}`
        }
    },
    // 时间格式
    timeFormat: function(params) {
        if (params) {
            let num = params.toString().slice(0, -3)
            if ([...num][0] == 1) {
                let [hour, minute] = [num.slice(0, 2), num.slice(2, 4)]
                return `${hour}:${minute}`
            } else {
                let [hour, minute] = [num.slice(0, 1), num.slice(1, 3)]
                return `0${hour}:${minute}`
            }
        }
    },
    // 价格格式-前部分
    priceIntFormat: function(params) {
        if (params) {
            let num = params.toString()
            if (num.indexOf('.') !== -1) {
                num = num.split('.')
                let len = num[1].length
                if (len < 4) {
                    return num[0] + '.'
                } else if (len == 4) {
                    return num[0] + '.' + num[1].slice(0, 2)
                } else {
                    return num[0] + '.' + num[1].slice(0, 2)
                }
            } else {
                return params
            }
        }
    },
    //价格格式-后部分
    priceDecFormat: function(params) {
        if (params) {
            let num = params.toString()
            if (num.indexOf('.') !== -1) {
                num = num.split('.')
                let len = num[1].length
                if (len < 4) {
                    return num[1]
                } else if (len == 4) {
                    return num[1].slice(2, 4)
                } else {
                    return num[1].slice(2, 5)
                }
            } else {
                return '';
            }
        }
    },
    // 数字格式
    numFormat: function(params) {
        if (params && typeof params == 'number') {
            if (Math.abs(params) >= 1000000000000) {
                return (params / 1000000000000).toFixed(2) + 'trillion'
            } else if (Math.abs(params) >= 100000000 && Math.abs(params) < 1000000000000) {
                return (params / 100000000).toFixed(2) + 'hundred million'
            } else if (Math.abs(params) >= 10000 && Math.abs(params) < 100000000) {
                return (params / 10000).toFixed(2) + 'ten thousa'
            } else {
                return params
            }
        } else {
            return params
        }
    },
    // 保证2位小数
    toFixed_2(params) {
        if (params && typeof params == 'number') {
            return params.toFixed(2)
        } else {
            return params
        }
    },
    // 保证3位小数
    toFixed_3(params) {
        if (params && typeof params == 'number') {
            return params.toFixed(3)
        } else {
            return params
        }
    },
    /**
     * 格式化数据
     */
    numberFormat: function(number, ratioFixed = 2) {
        // if (!isValidNumber(number) || !isValidNumber(ratioFixed)) {
        //   throw new Error(`${number} or ${ratioFixed} is not a valid number`);
        // }
        if (Math.abs(number) > 1000000000000) {
            return (Math.abs(number) / 1000000000000).toFixed(ratioFixed) + '万亿';
        } else if (number > 100000000) {
            return number > 0 ? (number / 100000000).toFixed(ratioFixed) + '亿' : (number / 100000000).toFixed(ratioFixed) + '亿'
        } else if (Math.abs(number) > 10000) {
            return number > 0 ? (number / 10000).toFixed(ratioFixed) + '万' : (number / 10000).toFixed(ratioFixed) + '万'
        } else {
            return number.toFixed(0);
        }
    }
}
export default filters;
